import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Pagination from "../../ResuableCompoment/Pagination";
import SearchBar from "../../ResuableCompoment/SearchBar";
import useApi from "../../CustomHooks/useApi";
import { useSelector } from "react-redux";

const OnboardingRejeceted = () => {
  const [loading, setLoading] = useState(true);
  const [formsData, setFormsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rawResponse, setRawResponse] = useState([]);

  /* 🔹 EDIT POPUP STATES */
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("confirm");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [merchantLoading, setMerchantLoading] = useState(false);

  const itemsPerPage = 10;
  const navigate = useNavigate();

  const userId = useSelector((state) => state.auth.employeeDetails.userId);
  const rolesuperonboarding = useSelector(
    (state) => state.auth.employeeDetails.role
  );

  const { callApi: pendingOnboard } = useApi(
    `/staff/onboard/get/reject`,
    "GET"
  );

  const { callApi: editmerchant } = useApi(
    `/staff/onboard/edit/user`,
    "POST"
  );

  useEffect(() => {
    fetchFormsData();
  }, []);

  const fetchFormsData = async () => {
    try {
      const response = await pendingOnboard(null, `?userId=${userId}`);
      setFormsData(response || []);
      setRawResponse(response || []);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  /* 🔹 EDIT HANDLERS */
  const handleEditClick = (userID) => {
    setSelectedUserId(userID);
    setPopupType("confirm");
    setPopupMessage("Are you sure you want to edit this merchant?");
    setShowPopup(true);
  };

  const handlePopupConfirm = async () => {
    setMerchantLoading(true);
    await editmerchant(null, `?userId=${selectedUserId}`);
    setMerchantLoading(false);
    setPopupType("success");
    setPopupMessage("Merchant moved to edit section successfully.");
  };

  const filteredForms = formsData.filter(
    (form) =>
      form.meta.fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      form.role.toLowerCase().includes(searchQuery.toLowerCase()) ||
      form.mobileNumber.includes(searchQuery) ||
      form.userId.includes(searchQuery)
  );

  return (
    <div className="min-h-screen bg-[#EEF1F5]">
      {/* SEARCH */}
      <div className="mb-6">
        <SearchBar
          placeholder="Search by Name, Role, or Mobile"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="bg-white p-8 rounded-2xl shadow-md"
      >
        <h2 className="text-xl font-semibold text-[#0A2A4F] text-center mb-6">
          Rejected Onboarding
        </h2>

        {loading ? (
          <div className="text-center text-gray-500">Loading data...</div>
        ) : filteredForms.length === 0 ? (
          <div className="text-center text-red-500">No data found</div>
        ) : (
          <Pagination
            items={filteredForms}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            renderItems={(currentItems) => (
              <>
                {/* ================= DESKTOP TABLE ================= */}
                <div className="hidden xl:block overflow-x-auto">
                  <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
                    <thead className="bg-[#0A2A4F] text-white">
                      <tr className="text-sm text-left">
                        <th className="px-4 py-2">Name</th>
                        <th className="px-4 py-2">Mobile</th>
                        <th className="px-4 py-2">PAN</th>
                        <th className="px-4 py-2">Role</th>
                        <th className="px-4 py-2">Onboarding</th>
                        <th className="px-4 py-2">Document</th>
                        <th className="px-4 py-2">Reason</th>
                        <th className="px-4 py-2 text-center">Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentItems.map((form, index) => (
                        <tr
                          key={index}
                          className="hover:bg-gray-50 transition border-b"
                        >
                          <td className="px-4 py-3">{form.meta.fullName}</td>
                          <td className="px-4 py-3">{form.mobileNumber}</td>
                          <td className="px-4 py-3">{form.panCard}</td>
                          <td className="px-4 py-3">{form.role}</td>
                          <td className="px-4 py-3">{form.onboardingStatus}</td>
                          <td className="px-4 py-3">{form.meta.Document_status}</td>
                          <td className="px-4 py-3 max-w-[150px]">
                            <div className="truncate" title={form.meta?.reason}>
                              {form.meta?.reason || "-"}
                            </div>
                          </td>
                          <td className="px-4 py-3 flex gap-2 justify-center">
                            <button
                              onClick={() => handleEditClick(form.userId)}
                              className="px-4 py-1.5 rounded-lg text-sm bg-[#0A2A4F] text-white hover:bg-[#08305e]"
                            >
                              Edit
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* ================= MOBILE CARD VIEW ================= */}
                <div className="xl:hidden space-y-4">
                  {currentItems.map((form, index) => (
                    <div
                      key={index}
                      className="bg-white border border-gray-200 rounded-xl shadow-sm p-4"
                    >
                      {/* Top Section */}
                      <div className="flex justify-between items-start mb-2">
                        <h3 className="text-sm font-semibold text-[#0A2A4F]">
                          {form.meta.fullName}
                        </h3>
                        <span className="text-xs bg-slate-100 px-2 py-1 rounded-full">
                          {form.role}
                        </span>
                      </div>

                      {/* Details */}
                      <div className="text-xs text-gray-600 space-y-1">
                        <p><span className="font-medium">Mobile:</span> {form.mobileNumber}</p>
                        <p><span className="font-medium">PAN:</span> {form.panCard}</p>
                        <p><span className="font-medium">Onboarding:</span> {form.onboardingStatus}</p>
                        <p><span className="font-medium">Document:</span> {form.meta.Document_status}</p>
                      </div>

                      {/* 🔴 REASON (FULL VISIBLE - FIXED) */}
                      <div className="mt-3">
                        <p className="text-xs font-medium text-gray-700 mb-1">Reason:</p>
                        <div className="text-xs text-red-600 bg-red-50 p-2 rounded-lg break-words">
                          {form.meta?.reason || "-"}
                        </div>
                      </div>

                      {/* Action */}
                      <div className="mt-3">
                        <button
                          onClick={() => handleEditClick(form.userId)}
                          className="w-full py-2 rounded-lg text-sm bg-[#0A2A4F] text-white hover:bg-[#08305e]"
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          />
        )}
      </motion.div>

      {/* 🔹 POPUP */}
      {showPopup && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-[380px] shadow-xl">
            <h3 className="text-lg font-semibold text-center mb-3">
              {popupType === "confirm" ? "Confirm" : "Success"}
            </h3>

            <p className="text-sm text-gray-600 text-center mb-6">
              {popupMessage}
            </p>

            <div className="flex justify-center gap-4">
              {popupType === "confirm" ? (
                <>
                  <button
                    onClick={() => setShowPopup(false)}
                    className="px-5 py-2 rounded-lg border"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handlePopupConfirm}
                    disabled={merchantLoading}
                    className="px-5 py-2 rounded-lg bg-[#0A2A4F] text-white"
                  >
                    {merchantLoading ? "Processing..." : "Confirm"}
                  </button>
                </>
              ) : (
                <button
                  onClick={() => setShowPopup(false)}
                  className="px-6 py-2 rounded-lg bg-[#0A2A4F] text-white"
                >
                  OK
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OnboardingRejeceted;



